import { render, staticRenderFns } from "./CockpitTable.vue?vue&type=template&id=cf734c0e"
import script from "./CockpitTable.vue?vue&type=script&lang=js"
export * from "./CockpitTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports